<template>
    <div>
        <b-card-header>
            <b-nav card-header tabs>
                <b-nav-item :to="{name: 'projects.project-management.services-to-complete', params: {projectId: project.id}}">
                    {{ $t('Services to complete') }}
                </b-nav-item>

                <b-nav-item :to="{name: 'projects.disabilities', params: {projectId: project.id}}">
                    {{ $t('Disabilities') }}
                </b-nav-item>

                <b-nav-item :to="{name: 'projects.weather', params: {projectId: project.id}}">
                    {{ $t('Weather') }}
                </b-nav-item>

                <b-nav-item :to="{name: 'projects.reports', params: {projectId: project.id}}">
                    {{ $t('Construction report') }}
                </b-nav-item>

                <b-nav-item :to="{name: 'projects.attachments', params: {projectId: project.id}}">
                    {{ $t('Attachments') }}
                </b-nav-item>
            </b-nav>
        </b-card-header>

        <router-view />
    </div>
</template>
<script>
    export default {
        name: 'ProjectManagement',
        props: {
            project: {
                type: Object,
                default: null,
            },
        },
    }
</script>
